/**
 * @class {RPC}
 * @param {String} url
 * @param {Object} [par]
 */
const RPC = Class(
	/**
	 * @lends {RPC#}
	 */
	{
		/**
		 * @param {String} url
		 * @param {Object} [par]
		 * @constructs
		 */
		__construct: function (url, par) {
			par = par || {};
			this.url = url;
			this.async = true;
			if (typeof par.async !== 'undefined') {
				this.async = Boolean(par.async);
			}
		},

		send: function (method, data, callback) {
			callback = callback || null;
			const xhr = new XMLHttpRequest();
			xhr.open('POST', this.url, this.async);
			xhr.setRequestHeader('Content-Type', 'application/json');
			xhr.setRequestHeader('ROADGAMES-LANG', D.LANG);

			xhr.onreadystatechange = function() {
				if (xhr.readyState === XMLHttpRequest.DONE) {
					if (xhr.status === 200) {
						this._response(callback, xhr.responseText);
					} else if (xhr.status === 403) {
						D.reload();
					}
				}
			}.bind(this);
			xhr.send(JSON.stringify({
				method: method,
				data: data
			}));
		},

		_response: function (callback, response) {
			if (!callback) {
				return;
			}
			let data = JSON.parse(response);
			if (typeof data !== 'object') {
				D.console.error(response);
				return;
			}
			if (typeof data.ok === 'undefined') {
				D.console.error(response);
				return;
			}
			try {
				callback(data.ok);
				if (!empty(data.ob)) {
					D.console.warn(data.ob);
				}
			} catch (e) {
				D.console.error(e);
			}
		}
	}
);